import React, { useState } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import { Timer, Users, Building } from 'lucide-react';

interface ContactModalProps {
  show: boolean;
  title: string;
  subtitle: string;
  onClose: () => void;
  onSubmit: (email: string) => void;
}

const ContactModal: React.FC<ContactModalProps> = ({
  show,
  title,
  subtitle,
  onClose,
  onSubmit
}) => {
  const [email, setEmail] = useState('');
  const [savedEmail, setSavedEmail] = useLocalStorage<string>('user_email', '');
  
  const stats = [
    { icon: <Users size={16} />, label: '2,500+ empresas confiam' },
    { icon: <Timer size={16} />, label: 'Setup em 24h' },
    { icon: <Building size={16} />, label: '97% renovam' }
  ];

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(email);
    setSavedEmail(email);
    setEmail('');
  };

  React.useEffect(() => {
    if (savedEmail && !email) {
      setEmail(savedEmail);
    }
  }, [savedEmail]);

  const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  if (!show) return null;

  return (
    <div 
      className="fixed inset-0 bg-[#103541]/70 flex items-center justify-center z-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="bg-white rounded-2xl max-w-md w-full p-8 animate-in slide-in-from-bottom duration-300">
        <div className="flex justify-between items-center gap-2 mb-4 text-xs text-[#2E6173]">
          {stats.map((stat, index) => (
            <div key={index} className="flex items-center gap-1">
              {stat.icon}
              <span>{stat.label}</span>
            </div>
          ))}
        </div>
        
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-[#103541] mb-2">{title}</h2>
          <p className="text-[#2E6173]">{subtitle}</p>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-6">
            <label htmlFor="email" className="block text-sm font-medium text-[#103541] mb-1">
              E-mail corporativo
            </label>
            <input
              type="email"
              id="email"
              className="w-full p-3 border border-gray-200 rounded-xl focus:ring-2 focus:ring-[#7AEA53] focus:border-transparent transition-all"
              placeholder="seu@email.com.br"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          
          <button
            type="submit"
            className="w-full py-4 bg-[#7AEA53] hover:bg-[#6DD142] text-white font-medium rounded-xl transition-all transform hover:-translate-y-1"
            disabled={!email}
          >
            {title.includes('demon') ? 'Agendar Demonstração' : 'Ver meu diagnóstico'}
          </button>
          
          <div className="mt-4 space-y-2">
            <p className="text-xs text-center text-[#2E6173]">
              🔒 Seus dados estão seguros e não serão compartilhados
            </p>
            <p className="text-xs text-center text-[#2E6173]">
              ⚡ Resposta em até 10 minutos em horário comercial
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactModal;